import React from 'react';
import { Zap, ArrowRight } from 'lucide-react';
import { appTemplates } from '../../templates';

const SUGGESTIONS = [
  { label: 'Build a full-stack app', prompt: 'Build me a full-stack task management app with React frontend, FastAPI backend, and MongoDB' },
  { label: 'Create a landing page', prompt: 'Build a modern SaaS landing page with hero, features, pricing, and testimonials sections' },
  { label: 'Add authentication', prompt: 'Add user authentication with email/password login, registration, and JWT tokens' },
  { label: 'Build an API', prompt: 'Build a REST API with CRUD endpoints, input validation, and proper error handling' },
];

const QUICK_TEMPLATES = appTemplates.slice(0, 4);

const fillInput = (text) => {
  const input = document.querySelector('[data-testid="chat-input"]');
  if (input) {
    const nativeSet = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;
    nativeSet.call(input, text);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  }
};

const ChatQuickStart = () => {
  return (
    <div className="max-w-2xl mx-auto" data-testid="chat-quick-start">
      {/* Quick Prompts */}
      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Quick start</p>
      <div className="grid grid-cols-2 gap-2 mb-4">
        {SUGGESTIONS.map((s, i) => (
          <button
            key={i}
            onClick={() => fillInput(s.prompt)}
            className="flex items-center gap-2 px-3 py-2 rounded-lg bg-muted border border-input hover:border-blue-500/40 hover:bg-secondary transition-all text-left group"
            data-testid={`quick-prompt-${i}`}
          >
            <Zap className="w-3.5 h-3.5 text-blue-400 shrink-0" />
            <span className="text-sm text-foreground/80 group-hover:text-foreground">{s.label}</span>
            <ArrowRight className="w-3 h-3 text-muted-foreground/70 group-hover:text-blue-400 ml-auto shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
          </button>
        ))}
      </div>

      {/* Quick Templates */}
      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Or start from a template</p>
      <div className="grid grid-cols-4 gap-2">
        {QUICK_TEMPLATES.map(t => (
          <button
            key={t.id}
            className="flex flex-col items-center gap-1.5 p-2.5 rounded-lg bg-muted border border-input hover:border-blue-500/30 hover:bg-secondary transition-all group"
            onClick={() => fillInput(`Build me a ${t.name.toLowerCase()}: ${t.description}`)}
            data-testid={`quick-template-${t.id}`}
          >
            <span className="text-xl group-hover:scale-110 transition-transform">{t.icon}</span>
            <span className="text-xs text-muted-foreground group-hover:text-foreground text-center leading-tight">{t.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChatQuickStart;
